<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="simple-row">
            <div class="left">
                <button class='swb-btn swb-btn-small mb10' @click="sendMsgDlg();">发信</button>
                <button class='swb-btn swb-btn-small mb10 fr' @click="getXMsgList();">刷新</button>
            </div>
        </div>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="xMsgList" border tooltip-effect="dark" style="width: 100%">
                <el-table-column width="180" label="单据号" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span v-if="rows.row.group == 'voucher' && rows.row.fieldx == 'servc_work'">{{rows.row.fieldy}}</span>
                        <span class="swb-btn-link" v-else-if="rows.row.group == 'voucher'" @click="toVoucherInfo(rows.row.fieldx, rows.row.fieldy,  rows.row.data)">{{rows.row.fieldy}}</span>
                        <span v-else>无</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="txt" width="220" label="标题" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" label="内容" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span v-if="rows.row.data != null && rows.row.data.indexOf('{') >= 0">{{ JSON.decode(rows.row.data).message }}</span>
                        <span v-else>{{rows.row.data}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="图片" align="center" width="70">
                    <template slot-scope="rows">
                            <span v-if="rows.row.url != null" @click="showImg(rows.row.url)">
                                <img :src="rows.row.url"/>
                            </span>
                    </template>
                </el-table-column>
                <el-table-column prop="sendTime" width="200" label="发送时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="caozuo" width="80" align="center" label="操作">
                    <template slot-scope="rows">
                        <div v-if="rows.row.data != null && rows.row.data.indexOf('{') >= 0">
                            <a class="swb-btn-link" v-if="!rows.row.notShowView" @click="msgInfo(rows.row)">查看</a>
                        </div>
                        <a class="swb-btn-link" v-else @click="msgInfo(rows.row)">查看</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import  { showMsgSendDlg }  from '../msg/dialog'
    import { voucherType } from '../../../resc/app/js/voucherType'
    import { sendMsgMail } from '../msg/dialog'
    import { getVoucherTypes } from '../../app.const'

    import comnApi from '../../api/comn'
    import merchtAllApi from '../../api/merchtAll'

    import SendMsg from './SendMsg'
    Vue.regist(SendMsg);

    // --------------- 合同 -------------
    import SwbGoodsPurchContractList from '../contract/GoodsPurchContractList'; // 设备采购合同
    Routes.add(SwbGoodsPurchContractList);
    import SwbServcPurchContractList from '../contract/ServcPurchContractList'; // 服务采购合同
    Routes.add(SwbServcPurchContractList);
    import SwbIntegPurchContractList from '../contract/IntegPurchContractList'; // 集成采购合同
    Routes.add(SwbIntegPurchContractList);

    // -------------- 询盘单 ---------------
    import SwbDealInqryVoucherList from '../InqryVoucher/DealInqryVoucherList';
    Routes.add(SwbDealInqryVoucherList);

    // -------------- 询价单 ---------------
    import SwbPriceInpryList from '../priceInpry/PriceInpryList';
    Routes.add(SwbPriceInpryList);

    // ------------- 招标书 ----------------
    import SwbCallBidDocList from '../callbid/CallBidDocList';
    Routes.add(SwbCallBidDocList);

    // ----------------- 发货单 ------------
    import SwbGoodsShipVoucherList from '../order/GoodsShipVoucherList';
    Routes.add(SwbGoodsShipVoucherList);

    // ----------------- 付款单据 --------------
    import SwbPayVoucherList from '../payment/PayVoucherList';      // 付款单据
    Routes.add(SwbPayVoucherList);

    // ----------------- 退款单据 --------------
    import SwbRefundVoucherOfVendorList from '../payment/RefundVoucherOfVendorList'; // 供应商退款单据
    Routes.add(SwbRefundVoucherOfVendorList);
    import SwbRefundVoucherOfServicerList from '../payment/RefundVoucherOfServicerList'; // 供应商退款单据
    Routes.add(SwbRefundVoucherOfServicerList);
    let searchConfigData = {
        "queryFields": [{
            "type": "Select",
            "label": "主题",
            "code": "selectFieldx",
            "basic": true,
            "valueType": "String",
            "dataList": [{
                "value": null,
                "label": "全部"
            }]
        }, {
            "type": "Text",
            "label": "标题",
            "code": "txt",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Date2",
            "label": "发送时间",
            "code": "sendTime",
            "basic": true,
            "valueType": "String"
        }],
        "sortFields": []
    };

    export default{
        name: 'swb-send-msg-list',
        desc: '站点信',
        props: {
            isVoucher: {
                type: Boolean,
                default: false
            },
            source: {
                type: String
            },
            group: {
                type: String
            },
            fieldx: {
                type: String
            },
            fieldy: {
                type: String
            },
            senderId: {
                type: String
            },
            receiverType: {
                type: String
            },
            receiverData: {}
        },
        data: function () {
            return {
                xMsgList: [],
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
            }
        },
        created: function () {
            //
            let voucherTypeList = Object.entries(getVoucherTypes());
            let voucherTypes = [];
            voucherTypes.push({"value": null, "label": "全部"});
            if(voucherTypeList != null && voucherTypeList.length > 0) {
                voucherTypeList.forEach(function (item) {
                    let queryItem = {};
                    queryItem.value = item[0];
                    queryItem.label = item[1];
                    voucherTypes.push(queryItem);
                })
            }
            let queryConfig = searchConfigData;
            let queryConfigMap = queryConfig.queryFields.toMap("code");
            let fieldxList = queryConfigMap['selectFieldx'];
            fieldxList.dataList = voucherTypes;
            this.queryConfig = Utils.merge({}, queryConfig);
            //
            this.getXMsgList();
        },
        methods: {
            msgInfo: function (row) {
                let self = this;
                Vue.$showDialog({
                    title: '查看站内信',
                    showCloseBtn: true,
                    okVisible: false,
                    cancelText: '关闭',
                    height: 650,
                    template: '<div class="simple-form">' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label>标题</label>' +
                    '</div>' +
                    '<div class="form-value">' +
                    '<label>{{txt}}</label>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label>内容</label>' +
                    '</div>' +
                    '<div class="form-value" v-if="isJson">{{JSON.decode(jsonData).message}}</div>' +
                    '<div class="form-value" v-else>{{jsonData}}</div>' +
                    '</div>' +
                    '<div class="form-group center" v-if="type == 1">' +
                    '<div class="form-label">' +
                    '<label>图片</label>' +
                    '</div>' +
                    '<div class="form-value" v-if="url != null"><img style="width:200px; height: 200px;" :src="url"/></div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        jsonData: row.data || '',
                        isJson: (row.data || '').startsWith('{') && (row.data || '').endsWith('}'),
                        txt: null,
                        type: row.type,
                        url: row.url,
                    },
                    methods: {},
                    okClicked: function () {
                    },
                    lifecycle: {
                        created: function () {
                            let selfDlg = this;
                            selfDlg.txt = row.txt;
                        }
                    }
                });
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.getXMsgList();
            },

            getXMsgList: function () {
                let self = this;
                let postData = {};
                postData.source = self.source || null;
                postData.group = self.group || null;
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                if(!Utils.isNoB(filterItems.selectFieldx) && filterItems.selectFieldx != "null") {
                    postData.fieldx = filterItems.selectFieldx;
                } else {
                    postData.fieldx = self.fieldx || null;
                }
                if(!Utils.isNoB(filterItems.txt)) {
                    postData.txt = filterItems.txt;
                }
                if(!Utils.isNoB(filterItems.sendTimeFrom)) {
                    postData.sendTimeFrom = filterItems.sendTimeFrom;
                }
                if(!Utils.isNoB(filterItems.sendTimeTo)) {
                    postData.sendTimeTo = filterItems.sendTimeTo;
                }
                postData.fieldy = self.fieldy || null;
                postData.senderId = self.senderId || null;
                let theLoad = MsgBox.loading();
                comnApi.getSendMsgList(postData, function (result) {
                    if(result.type == 'info') {
                        let xMsgList = result.data;
                        let returnMsgList = [];
                        if(!Utils.isNoB(self.receiverType)) {
                            if(xMsgList != null && xMsgList.length > 0) {
                                for(let i = 0; i < xMsgList.length; i++) {
                                    let msgInfo = xMsgList[i];
                                    if(Utils.isNoB(msgInfo.receiverType) || msgInfo.receiverType == self.receiverType) {
                                        returnMsgList.push(msgInfo);
                                    }
                                }
                            }
                        } else {
                            returnMsgList = xMsgList;
                        }
                        for(let i = 0; i < returnMsgList.length; i++) {
                            let msgInfo = returnMsgList[i];
                            if(!Utils.isNoB(msgInfo.data) && msgInfo.data.indexOf('{') >= 0) {
                                let currentData = JSON.decode(msgInfo.data);
                                msgInfo.notShowView = Utils.isTrue(currentData.notShowView);    // 不显示【查看】
                            }
                        }
                        self.xMsgList = returnMsgList;
                        /*self.totalCount = result.data.pagination.totalCount;*/
                    } else {
                        MsgBox.warning(result.message);
                    }
                    theLoad.hide();
                });
            },
            // 发信
            sendMsgDlg: function () {
                let isVoucher = this.isVoucher;
                if(isVoucher) {
                    let receiverData = this.receiverData;
                    // voucherChildType currentPostIds, currentMerchtType, otherPostIds, otherMerchtType
                    sendMsgMail(isVoucher, this.fieldy, this.fieldx, receiverData)
                } else {
                    sendMsgMail(isVoucher);
                }
            },
            /*sendMsgDlg: function () {
             let dlgArgs = {
             targetType: 'staff'
             };
             showMsgSendDlg(dlgArgs, function (resultData) {
             let postData = {};
             let msgInfo = resultData.msgInfo;
             postData.data = msgInfo.data;
             postData.txt = msgInfo.txt;
             postData.staffIds = resultData.staffIds;
             let theLoad = MsgBox.loading();
             merchtAllApi.sendSiteMsg(postData, function (result) {
             theLoad.hide();
             MsgBox.success("发送成功！");
             });
             });
             },*/
            // 各种单据跳转
            toVoucherInfo: function (type, no, data) {
                let self = this;
                console.log(type + "--" + no);
                let postData = {};
                let path = '';
                //
                switch(type) {
                    case voucherType.DEVC_REQR :
                        // ---------------- 设备请求 ---------------------
                        console.log("设备请求");

                        break;
                    case voucherType.DEAL_INQRY :
                        // 询盘单
                        console.log("询盘单");
                        //
                        postData.no = no;
                        path = SwbDealInqryVoucherList.path;
                        //
                        break;
                    case voucherType.DEAL_REPLY :
                        // 报盘单
                        console.log("报盘单");
                        // 供应商、服务商。注 ： 报盘 ，申请、审核、发布 未发送站内信！ 零售商不存在报盘！！
                        break;
                    case voucherType.PRICE_INQRY :
                        // 询价单
                        console.log("询价单");
                        //
                        postData.no = no;
                        path = SwbPriceInpryList.path;
                        //
                        break;
                    case voucherType.PRICE_REPLY :
                        // 报价单
                        console.log("报价单");
                        // 不存在零售商

                        break;
                    case voucherType.CALL_BID :
                        // 招标书
                        console.log("招标书");
                        //
                        postData.no = no;
                        path = SwbCallBidDocList.path;
                        //
                        break;
                    case voucherType.TEND_BID :
                        // 投标书
                        console.log("投标书");
                        break;
                    case voucherType.CONTRACT :
                        // ----------------- 合同 -----------------
                        console.log("合同");
                        console.log(data);
                        //
                        postData.no = no;
                        if(data.indexOf('{') >= 0) {
                            let jsonData = JSON.decode(data);
                            let contractType = jsonData.contractType;
                            if(getEnumInfoWith("contractType", "name", "GoodsPurch").value === contractType) {   // 商品采购合同
                                //
                                path = SwbGoodsPurchContractList.path;
                            } else if(getEnumInfoWith("contractType", "name", "ServcPurch").value === contractType) {    // 服务采购合同
                                //
                                path = SwbServcPurchContractList.path;
                            } else if(getEnumInfoWith("contractType", "name", "IntegPurch").value === contractType) {    // 集成采购合同
                                //
                                path = SwbIntegPurchContractList.path;
                            } else if(getEnumInfoWith("contractType", "name", "GoodsDeal").value === contractType) {    // 商品分销合同
                                // 零售商没有
                            } else if(getEnumInfoWith("contractType", "name", "GoodsAgent").value === contractType) {    // 商品代理合同
                                // 零售商没有
                            } else if(getEnumInfoWith("contractType", "name", "ServcDlgt").value === contractType) {    // 服务授权合同
                                // 零售商没有
                            } else {
                                MsgBox.warning("合同类型信息异常！");
                                return;
                            }
                        } else {
                            MsgBox.warning("合同站内信内容信息异常！");
                            return;
                        }
                        //
                        break;
                    case voucherType.GOODS_ORDER :
                        // 商品订单
                        console.log("商品订单");
                        // 商品订单没有站内信
                        break;
                    case voucherType.GOODS_SHIP :
                        // --------------------- 发货单 -----------------
                        console.log("发货单");
                        //
                        postData.no = no;
                        path = SwbGoodsShipVoucherList.path;
                        break;
                    case voucherType.GOODS_RECV :
                        // 收货单
                        console.log("收货单");
                        // 确认收货 未发送站内信
                        break;
                    case voucherType.SERVC_REQR :
                        // 服务请求单
                        console.log("服务请求单");
                        // 服务商
                        break;
                    case voucherType.SERVC_ORDER :
                        // 服务订单
                        console.log("服务订单");
                        // 服务订单没有 发送站内信
                        break;
                    case voucherType.SERVC_WORK :
                        // 服务派工单
                        console.log("服务派工单");
                        // 服务商-服务工程师
                        break;
                    case voucherType.PAY_VOUCHER :
                        // 支付单据
                        console.log("付款单据");
                        //
                        postData.no = no;
                        if(data.indexOf('{') >= 0) {
                            path = SwbPayVoucherList.path;
                        } else {
                            MsgBox.waning("付款单据站内信内容信息异常！");
                        }
                        break;
                    case voucherType.REFUND_VOUCHER :
                        // -------------------- 退款单据 --------------------
                        console.log("退款单据");
                        //
                        postData.no = no;
                        if(data.indexOf('{') >= 0) {
                            let jsonData = JSON.decode(data);
                            let sellerType = jsonData.sellerType;   // sellerType: 服务商支付单据、供应商支付单据
                            if(getEnumInfoWith("merchantType", "name", "Vendor").value === sellerType) {     // 供应商支付单据
                                //
                                path = SwbRefundVoucherOfVendorList.path;
                            } else if(getEnumInfoWith("merchantType", "name", "Servicer").value === sellerType) {    // 服务商支付单据
                                //
                                path = SwbRefundVoucherOfServicerList.path;
                            } else {
                                MsgBox.waning("支付单据卖家类型异常！");
                            }
                        } else {
                            MsgBox.waning("支付单据站内信内容信息异常！");
                        }
                        break;
                    default:
                        MsgBox.warning('单据类型异常！');
                }
                //
                if(!Utils.isNoB(path)) {
                    let hashUrl = Utils.makeUrl(path, postData);
                    openPageRouteUrl(null, "/bench/home", hashUrl);
                }
            },
            //
            showImg: function (url) {
                Utils.setPageUrl(url, '_blank');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/msg/SendMsgList.vue